var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":_vm.SkipSwitchName}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }